<script setup>
import { defineProps, computed } from "vue";
import { PROGRAM_MANAGER_LINKS } from "./constants.js";
import SubAppNavigation from "@/components/shared/Navigation/SubAppNavigation.vue";

const props = defineProps({
  headingTitle: {
    type: String,
    required: true,
  },
});

const subAppNavItems = computed(() => {
  return PROGRAM_MANAGER_LINKS.filter((item) => {
    return item.visible();
  });
});
</script>
<template>
  <div class="flex flex-row items-center justify-center">
    <h1 class="text-2xl font-semibold text-indigo-base mr-auto" data-testid="program-manager-v2">
      {{ props.headingTitle }}
    </h1>
    <SubAppNavigation :filtered-links="subAppNavItems" />
  </div>
</template>
